import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { TranslatorContext } from '@jutro/locale';
import { Link } from 'react-router-dom';
import { Icon } from '@jutro/components';
import tileStyles from './TileComponentExt.module.scss';

class TileComponentExt extends Component {
    /**
     * @memberof gw-components-platform-react.TilesComponent
     * @prop {Object} propTypes - the props that are passed to this component
     * @prop {string} propTypes.id - id of the component
     * @prop {string|Object} propTypes.title - title of the component
     * @prop {number} propTypes.value - value of the component
     * @prop {string} propTypes.tileIcon - material-ui icon that need to be displayed in component
     * @prop {boolean} propTypes.redirect - enable/disable page redirect
     * @prop {string} propTypes.redirectPath - used when redirect prop is set to true
     * @prop {string} propTypes.tileSize - size of tile - large/medium
     * @prop {function} propTypes.onClick - callback when tile is clicked
     * @prop {boolean} propTypes.active - mark tile as selected
     */

    static propTypes = {
        id: PropTypes.string.isRequired,
        title: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({
                id: PropTypes.string,
                defaultMessage: PropTypes.string
            }),
        ]).isRequired,
        value: PropTypes.number,
        tileIcon: PropTypes.string,
        redirect: PropTypes.bool,
        redirectPath: PropTypes.string,
        tileSize: PropTypes.string.isRequired,
        onClick: PropTypes.func,
        active: PropTypes.bool
    };

    static defaultProps = {
        value: null,
        tileIcon: '',
        redirect: false,
        redirectPath: '#',
        onClick: null,
        active: false,
    };

    tileClicked = (id) => {
        const { onClick } = this.props;

        if (onClick) {
            onClick(id);
        }
    };

    renderContent = () => {
        const {
            title, value, tileIcon, id, tileSize
        } = this.props;
        let tileHeaderColor = '';
        let gwTileContent=' ';
        const headerTitle = tileSize === 'large' ? <h1>{value}</h1> : <h2>{value}</h2>;

        if(id === 'commercialAccountsTile' || id==='PoliciesInforce' ){
            tileHeaderColor = cx(tileStyles.gwTileColor,tileStyles.commercialHeaderStyle, 'gwTilesColor');
            gwTileContent=cx(tileStyles.gwTileContent)
        }
        else if(id==='recentlyViewedTile'){

            gwTileContent=cx(tileStyles.gwRecentlyViewedTileContent)
            tileHeaderColor = cx(tileStyles.gwTileColor, 'gwTilesColor');
        }
        else if(id==='delinquentTile'){
            tileHeaderColor = cx(tileStyles.gwTileColor,tileStyles.delinquentTile, 'gwTilesColor');
            gwTileContent=cx(tileStyles.gwDelinquentTileContent)
        }
        else if(id==='quotes'){
            tileHeaderColor = cx(tileStyles.gwTileColor,tileStyles.quotes, 'gwTilesColor');
            gwTileContent=cx(tileStyles.gwQuoteTileContent)
        }
        else if(id==='renewal'){
            tileHeaderColor = cx(tileStyles.gwTileColor,tileStyles.quotes, 'gwTilesColor');
            gwTileContent=cx(tileStyles.gwTileContent)
        }
        else if(id==='completedQuotes' ){
            tileHeaderColor = cx(tileStyles.gwTileColor,tileStyles.completedQuotes, 'gwTilesColor');
            gwTileContent=cx(tileStyles.gwQuoteTileContent)
        }
        else if(id==='claims' || id==='openClaimsTile'){
            tileHeaderColor = cx(tileStyles.gwTileColor,tileStyles.claims, 'gwTilesColor');
            gwTileContent=cx(tileStyles.gwSummaryTileContent)
        }
        else if(id==='PremiumAudit'){
            tileHeaderColor = cx(tileStyles.gwTileColor,tileStyles.PremiumAudit, 'gwTilesColor');
            gwTileContent=cx(tileStyles.gwQuoteTileContent)
        }
        else if(id==='billingAndPayment' || id==='billing')
        {
            tileHeaderColor=cx(tileStyles.gwTileColor,tileStyles.billingAndPayment,'gwTilesColor')
            gwTileContent=cx(tileStyles.gwBillingTileContent)
        }
        else if(id==='documents'){
            tileHeaderColor = cx(tileStyles.gwTileColor,tileStyles.completedQuotes, 'gwTilesColor');
            gwTileContent=cx(tileStyles.gwSummaryTileContent)
        }
        else if(id==='payrollReporting')
        {
            tileHeaderColor=cx(tileStyles.gwTileColor,tileStyles.payrollReporting,'gwTilesColor')
            gwTileContent=cx(tileStyles.gwTileContent)
        }
        else if(id==='reportsAndSubscription'){
            tileHeaderColor=cx(tileStyles.gwTileColor,tileStyles.reportsAndSubscription,'gwTilesColor')
            gwTileContent=cx(tileStyles.gwTileContent)
        }
        else if (id==='summary')
        {
            tileHeaderColor=cx(tileStyles.gwTileColor,'gwTilesColor')
            gwTileContent=cx(tileStyles.gwSummaryTileContent)
        }

        else{
            tileHeaderColor = cx(tileStyles.gwTileColor, 'gwTilesColor');
            gwTileContent=cx(tileStyles.gwTileContent)
        }

        return (
            <TranslatorContext.Consumer>
                {(translator) => (
                        <div id={id}>
                            <div className={tileHeaderColor} />
                            {tileSize === 'large'? <div className={tileStyles.gwMainTileContent}><h4>{translator(title)}</h4></div> : <div className={tileStyles.gwMainTileContent}><span>{translator(title)}</span></div>}
                            <div className={gwTileContent}>
                                { tileIcon ? <Icon icon={tileIcon} className={tileStyles.tileIcon} /> : headerTitle}
                            </div>

                        </div>
                    )}
            </TranslatorContext.Consumer>
        );
    };

    renderTiles = () => {
        const {
            id, tileSize, active
        } = this.props;
        const tileWrapper = cx(tileStyles.gwTile, 'gwTileMainContent', {
            [tileStyles.gwActive]: active
        });
        const inputProps = { onClick: () => this.tileClicked(id) };
        const container = cx(tileStyles.gwTiles, {
            [tileStyles.gwTilesLarge]: tileSize === 'large',
            [tileStyles.gwTilesMedium]: tileSize === 'medium'
        });

        return (
            <div className={container}>
                <div className={tileStyles.gwTilesAligner}>
                    <div className={tileWrapper} {...inputProps}>
                        {this.renderContent()}
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const { redirect, redirectPath } = this.props;

        return redirect ? (
            <Link to={redirectPath} className={tileStyles.linkStyles}>
                {this.renderTiles()}
            </Link>
        ) : this.renderTiles();
    }
}

export default TileComponentExt;
